<template>
  <div>
    <h1>作業報告一覧</h1>
    <v-card outlined class="mb-5">
      <v-expansion-panels flat v-model="expandedPanel" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <span class="headline">検索条件</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="5">
                <DatePicker
                  v-model="dateFrom"
                  label="作業予定日From"
                  prepend-inner-icon="mdi-calendar"
                  type="day"
                  outlined
                  clearable
                  reactive
                />
              </v-col>
              <v-col cols="1">
                <p class="range-text text-center pt-4">〜</p></v-col
              >
              <v-col cols="5">
                <DatePicker
                  v-model="dateTo"
                  label="作業予定日To"
                  prepend-inner-icon="mdi-calendar"
                  type="day"
                  outlined
                  clearable
                  reactive
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <label cols="1">対象</label>
              </v-col>
              <v-col cols="11">
                <v-checkbox
                  v-model="personInCharge"
                  label="自身が作業責任者のみ"
                  color="black"
                />
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col>
                <label cols="1">対象</label>
              </v-col>
              <v-col cols="6">
                <v-checkbox
                  v-model="personInCharge"
                  label="自身が作業責任者のみ"
                  color="black"
                />
              </v-col>
              <v-col cols="5">
                <v-checkbox
                  v-model="referBack"
                  label="差し戻し状態のみ"
                  :color="referBackDateColor"
                />
              </v-col>
            </v-row> -->
            <!-- <v-row
              ><v-chip :color="referBackDateColor"
                >差し戻しのデータ</v-chip
              ></v-row
            > -->
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card-actions class="mx-2">
        <v-spacer></v-spacer>
        <Btn color="info" icon="file-import" @click="search()">取得</Btn>
      </v-card-actions>
    </v-card>
    <v-card class="d-flex justify-end " flat>
      <v-btn class="mx-2" color="success" @click="addspot()"
        >スポット作業追加</v-btn
      >
      <v-spacer></v-spacer>
      <!-- <v-card
        class="deep-orange lighten-4 elevation-0"
        width="50px"
        outlined
        tile
      ></v-card>
      <div class="elevation-0 ml-3 caption">差し戻しのデータ</div> -->
      <div class="text-center">
        <v-chip class="ma-2" color="red lighten-3">
          差戻
        </v-chip>

        <v-chip class="ma-2" color="light-blue lighten-4">
          作業完了書受領済
        </v-chip>

        <v-chip class="ma-2" color="light-green lighten-4">
          電子サインあり
        </v-chip>

        <v-chip class="ma-2" color="yellow">
          一時保存
        </v-chip>
      </div>
    </v-card>
    <v-card class="mt-5">
      <v-simple-table height="500px" fixed-header dense>
        <thead>
          <tr>
            <th style="width: 1%;"></th>
            <th style="width: 16%;">
              作業予定日
            </th>
            <th style="width: 14%;">
              作業予定時間
            </th>
            <th style="width: 16%;">
              作業責任者
            </th>
            <th style="width: 16%;">
              施設名
            </th>
            <th style="width: 10%;">
              作業内容
            </th>
            <th style="width: 10%;">
              進捗状況
            </th>
            <th style="width: 1%;"></th>
          </tr>
        </thead>
        <tbody v-if="listOfWorkReport.length > 0">
          <tr
            v-for="item in listOfWorkReport"
            :key="item.schedulePackage.keyId"
            :class="
              item.referBackStatus
                ? referBackDateColor
                : item.isSignExits
                ? 'light-green lighten-4'
                : item.isPaperSignExits
                ? 'light-blue lighten-4'
                : item.schedulePackage.state == 'TEMP'
                ? temporarySaveColor
                : ''
            "
          >
            <td>
              <div class="py-5 d-flex justify-center">
                <v-badge
                  :color="
                    item.isSignExits
                      ? 'success'
                      : item.isPaperSignExits
                      ? 'success'
                      : 'error'
                  "
                  icon="mdi-file-sign"
                >
                  <v-btn
                    :color="item.noEditPermission ? '' : 'error'"
                    @click="edit(item)"
                    >{{ item.noEditPermission ? "閲覧" : "編集" }}</v-btn
                  >
                </v-badge>
              </div>
            </td>
            <td>{{ item.schedulePackage.scheduleDate }}</td>
            <td>{{ item.estimatedWorkingTime }}</td>
            <td>{{ item.shain.userName }}</td>
            <td>{{ item.hospital.hospitalNm }}</td>
            <td>{{ item.mergedAllWorkPatternName }}</td>
            <!-- <td>
              <v-checkbox
                color="success"
                readonly
                v-model="item.isSignExits"
              ></v-checkbox>
            </td> -->
            <td>
              {{ item.stateOfProgress }}
            </td>
            <td>
              <div class="py-5 d-flex justify-center">
                <v-btn color="warning" @click="history(item)">履歴</v-btn>
              </div>
            </td>
            <!-- <td>
              <v-badge :content="item.badgeContent" color="success" overlap>
                <v-icon large>
                  mdi-file-sign
                </v-icon>
              </v-badge>
            </td> -->
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
    <v-dialog
      v-model="isEdit"
      fullscreen
      persistent
      hide-overlay
      eager
      transition="dialog-bottom-transition"
      v-if="isEdit"
    >
      <v-card class="pa-5" flat outlined>
        <v-toolbar class="flex-grow-0" elevation="0" color="primary" dark>
          <v-btn icon dark @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>
            作業完了報告書
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text ref="content" style="overflow-y: auto;">
          <v-form
            ref="form"
            v-model="valid"
            :disabled="completionReport.noEditPermission"
          >
            <v-row class="pt-5">
              <v-container class="custom-border">
                <v-row>
                  <v-col cols="5">
                    <v-text-field
                      v-model="completionReport.hospital.hospitalNm"
                      label="施設名"
                      outlined
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <DatePicker
                      v-model="completionReport.schedulePackage.executionDate"
                      label="作業実施日"
                      type="day"
                      outlined
                      :rules="[Rules.Required]"
                      clearable
                      reactive
                      :disabled="completionReport.noEditPermission"
                    />
                    <!-- <v-text-field
                    v-model="completionReport.schedulePackage.executionDate"
                    label="作業実施日"
                    outlined
                  ></v-text-field> -->
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="completionReport.shain.userName"
                      label="作業予定責任者"
                      outlined
                      readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-row>
            <v-row>
              <v-container class="custom-border">
                <!-- <v-row> -->
                <!-- <v-col cols="7"> -->
                <v-row>
                  <v-col>
                    <v-textarea
                      v-model="completionReport.mergedAllWorkPatternName"
                      label="作業名"
                      outlined
                      rows="1"
                      row-height="15"
                      auto-grow
                      readonly
                    ></v-textarea>
                  </v-col>
                </v-row>
                <!-- </v-col> -->
                <!-- <v-col cols="5"> -->
                <v-row>
                  <v-col>
                    <v-textarea
                      v-model="completionReport.mergedShainNameString"
                      label="作業予定者"
                      outlined
                      readonly
                      rows="1"
                      row-height="15"
                      auto-grow
                    ></v-textarea>
                  </v-col>
                </v-row>
                <!-- </v-col> -->
                <!-- </v-row> -->
              </v-container>
            </v-row>
            <v-row>
              <v-container class="custom-border">
                <v-row>
                  <v-col cols="6">
                    <v-container class="custom-border">
                      <v-row>
                        <v-col>
                          <label>作業サイクル</label>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <!-- <v-checkbox
                          v-model="completionReport.packageDetail.cycle"
                          :label="
                            `${completionReport.packageDetail.cycle}` + `ヶ月`
                          "
                          :value="checked"
                          readonly
                        /> -->
                          <label v-if="completionReport.packageDetail">
                            {{
                              `${completionReport?.packageDetail.cycle}` +
                                `ヶ月`
                            }}</label
                          >
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                  <v-col cols="6">
                    <div>
                      <v-text-field
                        v-model="completionReport.estimatedWorkingTime"
                        label="作業予定時間"
                        outlined
                        readonly
                      ></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-row>
            <v-row>
              <v-container class="custom-border">
                <v-row>
                  <v-col cols="6">
                    <v-container class="custom-border">
                      <v-row>
                        <!-- <label class="mt-8 ml-2">確認事項</label> -->
                        <v-checkbox
                          class="mx-2 mb-4"
                          v-model="confirmationItemStatus"
                          label="確認事項"
                          readonly
                          color="success"
                          :rules="[Rules.DuplicateCheck]"
                        />
                      </v-row>
                      <v-container class="custom-border">
                        <v-row>
                          <!-- <v-col> -->
                          <v-checkbox
                            class="mx-2"
                            v-model="completionReport.schedulePackage.greeting"
                            label="作業前あいさつ"
                            value="1"
                          />
                          <!-- </v-col>
                    <v-col> -->
                          <v-checkbox
                            class="mx-2"
                            v-model="completionReport.schedulePackage.safety"
                            label="安全確認"
                            value="1"
                          />
                          <!-- </v-col> -->
                          <!-- <v-col> -->
                          <v-checkbox
                            class="mx-2"
                            v-model="completionReport.schedulePackage.signage"
                            label="表示板"
                            value="1"
                          />
                          <v-checkbox
                            class="mx-2"
                            v-model="completionReport.schedulePackage.cone"
                            label="コーン＋チェーン"
                            value="1"
                            cols="auto"
                          />
                          <v-checkbox
                            class="mx-2"
                            v-model="
                              completionReport.schedulePackage.otherThing
                            "
                            label="その他"
                            value="1"
                          />
                          <div class="mx-2 mt-2">
                            <v-text-field
                              v-model="
                                completionReport.schedulePackage.otherThingText
                              "
                              label="その他内容"
                              :rules="
                                completionReport.schedulePackage.otherThing ==
                                '1'
                                  ? [Rules.Required]
                                  : []
                              "
                              outlined
                            ></v-text-field>
                          </div>
                        </v-row>
                      </v-container>
                    </v-container>
                  </v-col>
                  <v-col cols="6">
                    <v-container class="custom-border">
                      <v-row>
                        <label class="mt-8 ml-2">作業予定人員</label>
                      </v-row>
                      <v-row>
                        <v-col>
                          <div>
                            <v-text-field
                              v-model="completionReport.totalShainCount"
                              label="1日"
                              suffix="名"
                              type="number"
                              outlined
                              readonly
                            />
                          </div>
                        </v-col>
                        <v-col>
                          <div>
                            <v-text-field
                              v-model="completionReport.aiwaShainCount"
                              label="ア"
                              suffix="名"
                              type="number"
                              outlined
                              readonly
                            />
                          </div>
                        </v-col>
                        <v-col>
                          <div>
                            <v-text-field
                              v-model="completionReport.otherShainCount"
                              label="オ"
                              suffix="名"
                              type="number"
                              outlined
                              readonly
                            />
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
              </v-container>
            </v-row>
            <v-row
              v-for="(item,
              index) in completionReport.packageMeisaiResponseList"
              :key="index"
            >
              <v-container
                class="custom-border"
                v-if="item.scheduleMeisaiResponse"
              >
                <div class="fixed">
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="
                          item.scheduleMeisaiResponse.scheduleMeisai.workPattern
                        "
                        label="作業内容"
                        :rules="[Rules.Required]"
                        outlined
                        :background-color="
                          item.scheduleMeisaiResponse.scheduleMeisai.addFlag ==
                          '1'
                            ? addedStateColor
                            : ''
                        "
                      >
                        <template
                          v-slot:prepend
                          v-if="
                            item.scheduleMeisaiResponse.scheduleMeisai
                              .addFlag == '1' &&
                              completionReport.packageMeisaiResponseList
                                .length > 1
                          "
                        >
                          <v-icon
                            color="red"
                            @click="
                              deleteMeisai(
                                completionReport,
                                completionReport.packageMeisaiResponseList,
                                item.scheduleMeisaiResponse.scheduleMeisai
                              )
                            "
                          >
                            mdi-close
                          </v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="
                          item.scheduleMeisaiResponse.scheduleMeisai.floor
                        "
                        :background-color="
                          item.scheduleMeisaiResponse.scheduleMeisai.addFlag ==
                          '1'
                            ? addedStateColor
                            : ''
                        "
                        label="フロア"
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="
                          item.scheduleMeisaiResponse.scheduleMeisai.area
                        "
                        :background-color="
                          item.scheduleMeisaiResponse.scheduleMeisai.addFlag ==
                          '1'
                            ? addedStateColor
                            : ''
                        "
                        label="エリア"
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <v-row
                  v-for="(workArea, index) in item.scheduleMeisaiResponse
                    .scheduleWorkAreaList"
                  :key="index"
                >
                  <v-col cols="5">
                    <!-- <v-checkbox :label="workArea.workArea" /> -->

                    <v-text-field
                      class="mt-2"
                      :background-color="
                        workArea.addFlag == '1'
                          ? addedStateColor
                          : workArea.separationFlag == '1' &&
                            workArea.addFlag == '0'
                          ? changedStateColor
                          : ''
                      "
                      v-model="workArea.workArea"
                      :label="'作業箇所' + workArea.serialNumber"
                      :rules="[Rules.Required]"
                      outlined
                      ><template
                        v-slot:prepend
                        v-if="
                          workArea.addFlag == '1' &&
                            item.scheduleMeisaiResponse.scheduleWorkAreaList
                              .length > 1
                        "
                      >
                        <v-icon
                          color="red"
                          @click="
                            deleteWorkArea(
                              item.scheduleMeisaiResponse,
                              item.scheduleMeisaiResponse.scheduleWorkAreaList,
                              workArea
                            )
                          "
                        >
                          mdi-close
                        </v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <!-- <v-col cols="2">
                  <v-text-field
                    class="mt-2"
                    v-model="workArea.workAreaSuu"
                    label="元数"
                    type="number"
                    :min="0"
                    outlined
                    readonly
                  />
                </v-col> -->
                  <v-col cols="2">
                    <v-text-field
                      class="mt-2"
                      :background-color="
                        workArea.addFlag == '1'
                          ? addedStateColor
                          : workArea.separationFlag == '1' &&
                            workArea.addFlag == '0'
                          ? changedStateColor
                          : ''
                      "
                      v-model="workArea.workAreaZansuu"
                      label="残数"
                      type="number"
                      :min="0"
                      :suffix="`元` + (workArea.workAreaSuu ?? '')"
                      :disabled="!workArea.workAreaSuu"
                      outlined
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-row>
                      <v-col>
                        <v-checkbox
                          v-model="workArea.status"
                          label="実施"
                          value="1"
                          :background-color="
                            workArea.addFlag == '1'
                              ? addedStateColor
                              : workArea.separationFlag == '1' &&
                                workArea.addFlag == '0'
                              ? changedStateColor
                              : ''
                          "
                          @change="changeOther('status', workArea)"
                          :rules="
                            workArea.status == '1' ||
                            workArea.processingScheduleNextmonth == '1' ||
                            workArea.processingScheduleHold == '1' ||
                            workArea.processingScheduleNextcycle == '1'
                              ? []
                              : ['']
                          "
                        />
                      </v-col>
                      <v-col>
                        <v-checkbox
                          v-model="workArea.processingScheduleNextmonth"
                          label="次月"
                          :background-color="
                            workArea.addFlag == '1'
                              ? addedStateColor
                              : workArea.separationFlag == '1' &&
                                workArea.addFlag == '0'
                              ? changedStateColor
                              : ''
                          "
                          value="1"
                          @change="changeOther('nextmonth', workArea)"
                          :rules="
                            workArea.status == '1' ||
                            workArea.processingScheduleNextmonth == '1' ||
                            workArea.processingScheduleHold == '1' ||
                            workArea.processingScheduleNextcycle == '1'
                              ? []
                              : ['']
                          "
                        />
                      </v-col>
                      <v-col>
                        <v-checkbox
                          v-model="workArea.processingScheduleHold"
                          label="日程"
                          :background-color="
                            workArea.addFlag == '1'
                              ? addedStateColor
                              : workArea.separationFlag == '1' &&
                                workArea.addFlag == '0'
                              ? changedStateColor
                              : ''
                          "
                          value="1"
                          @change="changeOther('hold', workArea)"
                          :rules="
                            workArea.status == '1' ||
                            workArea.processingScheduleNextmonth == '1' ||
                            workArea.processingScheduleHold == '1' ||
                            workArea.processingScheduleNextcycle == '1'
                              ? []
                              : ['']
                          "
                        />
                      </v-col>
                      <v-col>
                        <v-checkbox
                          v-model="workArea.processingScheduleNextcycle"
                          label="次回"
                          :background-color="
                            workArea.addFlag == '1'
                              ? addedStateColor
                              : workArea.separationFlag == '1' &&
                                workArea.addFlag == '0'
                              ? changedStateColor
                              : ''
                          "
                          value="1"
                          @change="changeOther('nextcycle', workArea)"
                          :rules="
                            workArea.status == '1' ||
                            workArea.processingScheduleNextmonth == '1' ||
                            workArea.processingScheduleHold == '1' ||
                            workArea.processingScheduleNextcycle == '1'
                              ? []
                              : ['']
                          "
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <!-- </div> -->
                <v-btn
                  outlined
                  color="blue-grey"
                  v-if="completionReport?.schedulePackage.packageNo < 0"
                  @click="
                    addScheduleWorkArea(
                      item.scheduleMeisaiResponse.scheduleWorkAreaList,
                      item.scheduleMeisaiResponse.scheduleMeisai
                    )
                  "
                >
                  <v-icon left>
                    mdi-plus
                  </v-icon>
                  作業箇所追加
                </v-btn>
              </v-container>
            </v-row>
            <v-row>
              <v-container class="custom-border">
                <v-btn
                  outlined
                  color="blue-grey"
                  v-if="completionReport?.schedulePackage.packageNo < 0"
                  @click="
                    addScheduleMeisai(
                      completionReport.packageMeisaiResponseList
                    )
                  "
                >
                  <v-icon left>
                    mdi-plus
                  </v-icon>
                  作業内容追加
                </v-btn>
              </v-container>
            </v-row>
            <v-row>
              <v-container class="custom-border">
                <v-row>
                  <v-col cols="5">
                    <v-container
                      class="custom-border fill-height"
                      :style="
                        completionReport.schedulePackage &&
                        completionReport.schedulePackage.executionWorkTime ==
                          '00:00'
                          ? { border: '2px solid #ff5252' }
                          : {}
                      "
                    >
                      <v-row
                        v-if="
                          completionReport.schedulePackage &&
                            completionReport.schedulePackage
                              .executionWorkTime == '00:00'
                        "
                      >
                        <span
                          class="ml-2"
                          style="color: #ff5252; font-size: 16px;"
                          >作業時間または、休憩時間の入力に誤りがあります。</span
                        >
                      </v-row>
                      <v-row><label class="mt-8 ml-2">作業時間</label></v-row>
                      <v-row class="ml-1 mt-5">
                        <div>
                          <TimePicker2
                            v-model="
                              completionReport.schedulePackage
                                .executionStartTime
                            "
                            placeholder="開始"
                            inputWidth="5em"
                            hide-details="auto"
                            close-on-complete
                            hour-label=" "
                            minute-label=" "
                            :minute-interval="15"
                            hideClearButton
                            :disabled="completionReport.noEditPermission"
                          />
                        </div>
                        <div class="justify-center">
                          <p class="pa-2">～</p>
                        </div>
                        <div>
                          <TimePicker2
                            v-model="
                              completionReport.schedulePackage.executionEndTime
                            "
                            inputWidth="5em"
                            placeholder="終了"
                            hide-details="auto"
                            close-on-complete
                            hour-label=" "
                            minute-label=" "
                            :minute-interval="15"
                            hideClearButton
                            :disabled="completionReport.noEditPermission"
                          />
                        </div>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-row><label class="mt-8 ml-2">休憩</label></v-row>
                          <v-row>
                            <v-col>
                              <div>
                                <TimePicker2
                                  v-model="
                                    completionReport.schedulePackage
                                      .executionRestTime
                                  "
                                  inputWidth="5em"
                                  placeholder="時間"
                                  hide-details="auto"
                                  close-on-complete
                                  hour-label=" "
                                  minute-label=" "
                                  :minute-interval="15"
                                  hideClearButton
                                  :rules="[Rules.Required]"
                                  :disabled="completionReport.noEditPermission"
                                />
                                <!-- <v-text-field
                            v-model="
                              completionReport.schedulePackage.executionWorkTime
                            "
                            label="実績"
                            suffix="H"
                            outlined
                          /> -->
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col>
                          <v-row><label class="mt-8 ml-2">実績</label></v-row>
                          <v-row>
                            <v-col>
                              <div>
                                <ReadOnlyTimePicker
                                  v-model="
                                    completionReport.schedulePackage
                                      .executionWorkTime
                                  "
                                  inputWidth="5em"
                                  placeholder="時間"
                                  hide-details="auto"
                                  close-on-complete
                                  hour-label=" "
                                  minute-label=" "
                                  :minute-interval="15"
                                  hideClearButton
                                  :disabled="completionReport.noEditPermission"
                                />
                                <!-- <v-text-field
                            v-model="
                              completionReport.schedulePackage.executionWorkTime
                            "
                            label="実績"
                            suffix="H"
                            outlined
                          /> -->
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <!-- <v-col>
                        <div>
                          <v-text-field
                            v-model="
                              completionReport.schedulePackage.executionRestTime
                            "
                            label="休憩時間"
                            suffix="H"
                            outlined
                          />
                        </div>
                      </v-col> -->
                      </v-row>
                    </v-container>
                  </v-col>
                  <v-col cols="7">
                    <v-row>
                      <!-- <v-col>
                      <div>
                        <v-text-field
                          v-model="
                            completionReport.schedulePackage.executionWorkTime
                          "
                          label="実績"
                          suffix="H"
                          outlined
                        />
                      </div>
                    </v-col>
                    <v-col>
                      <div>
                        <v-text-field
                          v-model="
                            completionReport.schedulePackage.executionRestTime
                          "
                          label="休憩時間"
                          suffix="H"
                          outlined
                        />
                      </div>
                    </v-col> -->
                      <v-col>
                        <div>
                          <v-text-field
                            :value="
                              Number(
                                completionReport.schedulePackage.workerAiwa
                              ) +
                                Number(
                                  completionReport.schedulePackage.workerOuen
                                )
                            "
                            label="1日"
                            type="number"
                            suffix="名"
                            :min="0"
                            readonly
                            outlined
                          />
                        </div>
                      </v-col>
                      <v-col>
                        <div>
                          <v-text-field
                            v-model="
                              completionReport.schedulePackage.workerAiwa
                            "
                            label="ア"
                            type="number"
                            suffix="名"
                            :min="0"
                            :rules="
                              completionReport.schedulePackage.workerAiwa >= 0
                                ? []
                                : ['']
                            "
                            outlined
                          />
                        </div>
                      </v-col>
                      <v-col>
                        <div>
                          <v-text-field
                            v-model="
                              completionReport.schedulePackage.workerOuen
                            "
                            label="オ"
                            suffix="名"
                            type="number"
                            :min="0"
                            :rules="
                              completionReport.schedulePackage.workerOuen >= 0
                                ? []
                                : ['']
                            "
                            outlined
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-row>
            <v-row>
              <v-container class="custom-border">
                <v-row>
                  <label class="mt-8 ml-2">残箇所</label>
                  <!-- <v-col cols="auto"> -->
                  <v-checkbox
                    class="mt-7 mx-2"
                    v-model="completionReport.schedulePackage.remainFlag"
                    label="無"
                    value="0"
                    :rules="[Rules.Required]"
                  />
                  <!-- </v-col>
          <v-col cols="auto"> -->
                  <v-checkbox
                    class="mt-7 mx-2"
                    v-model="completionReport.schedulePackage.remainFlag"
                    label="有"
                    value="1"
                    :rules="[Rules.Required]"
                  />
                  <!-- </v-col> -->
                </v-row>
              </v-container>
            </v-row>
            <v-row>
              <v-container class="custom-border">
                <!-- <v-row> -->

                <v-col col="12">
                  <v-row>
                    <label class="mt-7 mr-3">残理由</label>
                    <!-- <v-row> -->
                    <v-checkbox
                      v-model="completionReport.schedulePackage.remainReson"
                      label="施設様からの要請"
                      class="mr-4 mt-6"
                      value="1"
                      :rules="
                        processingScheduleNextMonthFlag == '1' ||
                        processingScheduleHoldFlag == '1' ||
                        processingScheduleNextCycleFlag == '1'
                          ? [Rules.Required]
                          : []
                      "
                    />
                    <div>
                      <v-text-field
                        v-model="completionReport.schedulePackage.hospitalTanto"
                        prefix="(担当者："
                        suffix="様)"
                        class="mr-10 mt-3"
                        outlined
                        :rules="
                          completionReport.schedulePackage.remainReson == '1'
                            ? [Rules.Required]
                            : []
                        "
                      />
                    </div>
                  </v-row>
                  <v-row>
                    <v-textarea
                      v-model="
                        completionReport.schedulePackage.hospitalRemainBiko
                      "
                      label="残理由"
                      outlined
                      rows="1"
                      row-height="15"
                      auto-grow
                      :rules="
                        completionReport.schedulePackage.remainReson == '1'
                          ? [Rules.Required]
                          : []
                      "
                    ></v-textarea>
                    <!-- </v-row> -->
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-row>
                    <v-checkbox
                      v-model="completionReport.schedulePackage.remainReson"
                      label="自社都合"
                      class="mb-2"
                      value="2"
                      :rules="
                        processingScheduleNextMonthFlag == '1' ||
                        processingScheduleHoldFlag == '1' ||
                        processingScheduleNextCycleFlag == '1'
                          ? [Rules.Required]
                          : []
                      "
                    />
                  </v-row>
                  <v-row>
                    <v-textarea
                      v-model="completionReport.schedulePackage.remainBiko"
                      label="残理由"
                      outlined
                      rows="1"
                      row-height="15"
                      auto-grow
                      :rules="
                        completionReport.schedulePackage.remainReson == '2'
                          ? [Rules.Required]
                          : []
                      "
                    ></v-textarea>
                  </v-row>
                </v-col>
                <!-- </v-row> -->
              </v-container>
            </v-row>
            <v-row>
              <v-container class="custom-border">
                <v-row>
                  <v-col>
                    <label>処理予定</label>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="2">
                    <v-checkbox
                      v-model="processingScheduleNextMonthFlag"
                      label="次月対応"
                      value="1"
                      readonly
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox
                      v-model="processingScheduleHoldFlag"
                      label="日程検討"
                      value="1"
                      readonly
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-checkbox
                      v-model="processingScheduleNextCycleFlag"
                      label="次回サイクル対応"
                      value="1"
                      readonly
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="
                        completionReport.schedulePackage.processingScheduleTanto
                      "
                      prefix="(担当者："
                      suffix="様)"
                      outlined
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-row>
            <v-row>
              <v-container class="custom-border">
                <v-row>
                  <label
                    class="mt-5 ml-2"
                    :class="{
                      'error--text':
                        (completionReport.changePlace ||
                          completionReport.addPlace) &&
                        completionReport.schedulePackage.reportChange !== '1' &&
                        completionReport.schedulePackage.reportAddIn !== '1' &&
                        completionReport.schedulePackage.reportAddOut !== '1'
                    }"
                    >変更内容</label
                  >

                  <v-checkbox
                    class="ml-2"
                    v-model="completionReport.schedulePackage.reportChange"
                    label="変更"
                    value="1"
                    hide-details
                  />
                  <v-checkbox
                    class="ml-2"
                    v-model="completionReport.schedulePackage.reportAddIn"
                    label="追加（契約内）"
                    value="1"
                    hide-details
                  />
                  <v-checkbox
                    class="ml-2"
                    v-model="completionReport.schedulePackage.reportAddOut"
                    label="追加（契約外）"
                    value="1"
                    hide-details
                  />
                </v-row>
                <v-row
                  v-if="
                    completionReport.changePlace || completionReport.addPlace
                  "
                >
                  <v-input
                    class="ml-2"
                    :value="
                      completionReport.schedulePackage.reportChange == '1' ||
                        completionReport.schedulePackage.reportAddIn == '1' ||
                        completionReport.schedulePackage.reportAddOut == '1'
                    "
                    :rules="[
                      v =>
                        v ||
                        '変更・追加（契約内）・追加（契約外）のいずれかを選択してください'
                    ]"
                    hide-details="auto"
                  />
                </v-row>
              </v-container>
            </v-row>
            <v-row>
              <v-container class="custom-border">
                <v-textarea
                  v-model="completionReport.changePlace"
                  label="変更場所"
                  rows="1"
                  row-height="15"
                  auto-grow
                  readonly
                ></v-textarea>
                <v-text-field
                  v-model="completionReport.schedulePackage.changeReason"
                  label="理由"
                  :rules="[
                    completionReport.schedulePackage.reportChange == '1'
                      ? Rules.Required
                      : true
                  ]"
                />
              </v-container>
            </v-row>
            <v-row>
              <v-container class="custom-border">
                <v-textarea
                  class="mt-3"
                  v-model="completionReport.addPlace"
                  label="追加場所"
                  rows="1"
                  row-height="15"
                  auto-grow
                  readonly
                ></v-textarea>

                <v-text-field
                  v-model="completionReport.schedulePackage.addReason"
                  label="理由"
                  :rules="[
                    completionReport.schedulePackage.reportAddIn == '1' ||
                    completionReport.schedulePackage.reportAddOut == '1'
                      ? Rules.Required
                      : true
                  ]"
                />
              </v-container>
            </v-row>
            <v-row>
              <v-container class="custom-border">
                <label class="mt-8">人員変更</label>
                <div>
                  <v-text-field
                    v-model="completionReport.schedulePackage.tantoUpdateInfo"
                    label="変更内容"
                  />
                </div>
                <div>
                  <v-text-field
                    v-model="completionReport.schedulePackage.tantoUpdateReason"
                    label="理由"
                  />
                </div>
              </v-container>
            </v-row>
            <v-row>
              <v-container class="custom-border">
                <v-textarea
                  v-model="completionReport.schedulePackage.biko"
                  label="備考"
                  outlined
                  rows="1"
                  row-height="15"
                  auto-grow
                ></v-textarea>
              </v-container>
            </v-row>
            <v-row>
              <v-container class="custom-border">
                <v-textarea
                  v-model="completionReport.approvalComment"
                  label="コメント"
                  outlined
                  rows="1"
                  row-height="15"
                  auto-grow
                  :rules="
                    completionReport.referBackStatus ||
                    completionReport.schedulePackage.paperSignFlg == '1'
                      ? [Rules.Required]
                      : []
                  "
                ></v-textarea>
              </v-container>
            </v-row>
            <v-row>
              <v-container class="custom-border">
                <div class="d-flex justify-center">
                  <VueSignaturePad
                    width="500px"
                    height="250px"
                    ref="signaturePad"
                    id="signature"
                    :options="{
                      penColor: 'red',
                      resizeHandler,
                      onEnd: onSignatureDrawn
                    }"
                  />
                </div>
                <div class="py-5 d-flex justify-center">
                  <v-btn
                    color="error"
                    @click="clear()"
                    :disabled="disableClearBtn"
                    >Clear</v-btn
                  >
                  <v-checkbox
                    class="mt-0 ml-3"
                    :key="paperSignKey"
                    :input-value="
                      completionReport.schedulePackage.paperSignFlg == '1'
                    "
                    label="作業完了書で受領済み"
                    @click.stop.prevent="onPaperSignClick"
                    :disabled="completionReport.noEditPermission || !valid"
                  />
                </div>
              </v-container>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="pt-8">
          <Btn
            color="success"
            @click="click(true)"
            :disabled="
              completionReport.noEditPermission ||
                disableSave ||
                hasSignature ||
                !!completionReport.schedulePackage.digitalSign ||
                completionReport.schedulePackage.paperSignFlg == '1' ||
                inspecting
            "
            >一時保存</Btn
          >
          <Btn
            color="orange"
            @click="onAdd()"
            :disabled="
              completionReport.noEditPermission || disableSave || inspecting
            "
            v-if="completionReport?.schedulePackage.packageNo > 0"
            >追加作業</Btn
          >
          <v-spacer></v-spacer>

          <Btn
            @click="inspect()"
            color="success"
            :disabled="disableClearBtn"
            :loading="inspecting"
          >
            閲覧
          </Btn>

          <Btn color="primary" @click="onClose()" :disabled="inspecting"
            >閉じる</Btn
          >
          <Btn
            color="success"
            @click="click(false)"
            :disabled="
              completionReport.noEditPermission || disableSave || inspecting
            "
            >登録</Btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isHistory"
      persistent
      max-width="500px"
      transition="dialog-bottom-transition"
      v-if="isHistory"
    >
      <v-card class="pa-5" flat outlined>
        <v-toolbar class="flex-grow-0" elevation="0" color="primary" dark>
          <v-btn icon dark @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>
            作業完了承認コメント履歴
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-simple-table fixed-header dense height="250">
            <thead>
              <tr>
                <th>
                  日時
                </th>
                <th>
                  登録者
                </th>
                <th>
                  コメント
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item,
                index) in completionReport.approvalCommentHistoryResponseList"
                :key="index"
              >
                <td>{{ item.addDatetime }}</td>
                <td>{{ item.userName }}</td>
                <td>{{ item.comment }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions class="pt-8">
          <v-spacer></v-spacer>
          <Btn color="primary" @click="onClose()">閉じる</Btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="openPdfViewer"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card class="d-flex flex-column" style="height: 100vh;">
        <v-toolbar dense color="primary" dark flat class="flex-grow-0">
          <v-toolbar-title>定期作業完了書プレビュー</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text dark @click="downloadExcel">
            <v-icon left>mdi-file-excel</v-icon>Excel ダウンロード
          </v-btn>
          <v-btn icon @click="closePdfViewer">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0 flex-grow-1" style="overflow: hidden;">
          <iframe
            v-if="pdfUrl"
            :src="pdfUrl"
            style="width:100%; height:100%; border:none;"
          ></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// mixins
import Common from "@/mixins/common";
import ShowDialogs from "@/mixins/showDialogs";

import Api from "@/mixins/api";
import { VueSignaturePad } from "vue-signature-pad";
import TimePicker2 from "@/components/TimePicker2.vue";
import ReadOnlyTimePicker from "@/components/ReadOnlyTimePicker.vue";
import ScheduleFixDialog from "./dialogs/ScheduleFixDialog.vue";
import Forms from "@/mixins/forms";

const DATE = new Date();
const DATENOW =
  DATE.getFullYear() +
  "-" +
  ("00" + Number(DATE.getMonth() + 1)).slice(-2) +
  "-" +
  ("00" + Number(DATE.getDate())).slice(-2);
export default {
  name: "WorkReport",
  mixins: [Common, ShowDialogs, Api, TimePicker2, Forms, ReadOnlyTimePicker],
  components: {
    VueSignaturePad
  },
  data: () => ({
    addedStateColor: "yellow lighten-5",
    changedStateColor: "blue lighten-5",
    valid: true,
    paperSignKey: 0,
    disableClearBtn: false,
    confirmationItemStatus: false,
    disableSave: false,
    hasSignature: false,
    isHistory: false,
    //referBackDateColor: "deep-orange lighten-4",
    referBackDateColor: "red lighten-3", //"yellow",
    noSignEntryColor: "deep-orange lighten-4",
    temporarySaveColor: "yellow", //"light-blue lighten-4",
    processingScheduleNextMonthFlag: "0",
    processingScheduleHoldFlag: "0",
    processingScheduleNextCycleFlag: "0",
    personInCharge: true,
    //referBack: true,
    isDataExits: false,
    options: {
      penColor: "red" //,
    },
    completionReport: {
      hospital: {
        hospitalNm: ""
      },
      schedulePackage: {
        executionDate: ""
      },
      shain: {
        userName: ""
      },
      packageDetail: {
        cycle: ""
      },
      packageMeisaiResponseList: []
    },
    expandedPanel: [0],
    isEdit: false,
    listOfWorkReport: [],
    dateFrom: DATENOW,
    dateTo: DATENOW,
    facilityName: "岸和田徳州会",
    workDetail: "床面洗浄及びワックス塗布作業",
    estimatedWorkTime: "9:00 ～ 16:00 （3名）",
    openPdfViewer: false,
    pdfUrl: null,
    inspecting: false, // 閲覧ボタン（PDF生成）中のローディング制御
    formdata: new FormData(),
    data: null
  }),
  computed: {},
  watch: {
    valid: {
      handler: function(newVal, oldVal) {
        console.log(
          "valid check",
          newVal,
          oldVal,
          this.completionReport.noEditPermission
        );
        if (this.completionReport.schedulePackage.paperSignFlg == "1") {
          this.$refs.signaturePad.clearSignature();
          this.$refs.signaturePad.lockSignaturePad();
          this.disableClearBtn = true;
        } else if (!newVal || this.completionReport.noEditPermission) {
          this.$refs.signaturePad.lockSignaturePad();
          this.disableClearBtn = true;
        } else {
          this.$refs.signaturePad.openSignaturePad();
          this.disableClearBtn = false;
        }
      }
    },
    completionReport: {
      handler: function(newVal, oldVal) {
        console.log("watch completionReport", newVal, oldVal);
        const foundProcessingScheduleNextmonth = newVal.packageMeisaiResponseList.find(
          item =>
            item.scheduleMeisaiResponse?.scheduleWorkAreaList.find(
              workArea => workArea.processingScheduleNextmonth == "1"
            )
        );

        if (foundProcessingScheduleNextmonth)
          this.processingScheduleNextMonthFlag = "1";
        else this.processingScheduleNextMonthFlag = "0";

        console.log(
          "foundProcessingScheduleNextmonth",
          foundProcessingScheduleNextmonth,
          this.processingScheduleNextMonthFlag
        );

        const foundProcessingScheduleHold = newVal.packageMeisaiResponseList.find(
          item =>
            item.scheduleMeisaiResponse?.scheduleWorkAreaList.find(
              workArea => workArea.processingScheduleHold == "1"
            )
        );

        if (foundProcessingScheduleHold) this.processingScheduleHoldFlag = "1";
        else this.processingScheduleHoldFlag = "0";
        console.log(
          "foundProcessingScheduleHold",
          foundProcessingScheduleHold,
          this.processingScheduleHoldFlag
        );

        const foundProcessingScheduleNextCycle = newVal.packageMeisaiResponseList.find(
          item =>
            item.scheduleMeisaiResponse?.scheduleWorkAreaList.find(
              workArea => workArea.processingScheduleNextcycle == "1"
            )
        );

        if (foundProcessingScheduleNextCycle)
          this.processingScheduleNextCycleFlag = "1";
        else this.processingScheduleNextCycleFlag = "0";
        console.log(
          "foundProcessingScheduleNextCycle",
          foundProcessingScheduleNextCycle,
          this.processingScheduleNextCycleFlag
        );

        const confirmationItem = [];
        confirmationItem.push(newVal.schedulePackage.greeting);
        confirmationItem.push(newVal.schedulePackage.safety);
        confirmationItem.push(newVal.schedulePackage.signage);
        confirmationItem.push(newVal.schedulePackage.cone);
        confirmationItem.push(newVal.schedulePackage.otherThing);
        console.log("confirmationItem", confirmationItem);
        const totalConfirmedItem = confirmationItem.filter(
          status => status == "1"
        );

        if (totalConfirmedItem < 2) this.confirmationItemStatus = false;
        else this.confirmationItemStatus = true;

        const executionStartTimeSplited = newVal.schedulePackage.executionStartTime.split(
          ":"
        );
        const executionEndTimeSplited = newVal.schedulePackage.executionEndTime.split(
          ":"
        );

        const executionRestTimeSplited = newVal.schedulePackage.executionRestTime.split(
          ":"
        );

        const executionStartTimeHour = Number(executionStartTimeSplited[0]);
        const executionStartTimeMinute = Number(executionStartTimeSplited[1]);

        const executionEndTimeHour = Number(executionEndTimeSplited[0]);
        const executionEndTimeMinute = Number(executionEndTimeSplited[1]);

        const executionRestTimeHour = Number(executionRestTimeSplited[0]);
        const executionRestTimeMinute = Number(executionRestTimeSplited[1]);

        const workTimeHour =
          executionEndTimeHour >= executionStartTimeHour
            ? executionEndTimeHour - executionStartTimeHour
            : 24 - executionStartTimeHour + executionEndTimeHour;

        const workTimeMinute =
          executionEndTimeMinute >= executionStartTimeMinute
            ? executionEndTimeMinute - executionStartTimeMinute
            : executionStartTimeMinute - executionEndTimeMinute;

        const totalWorkTime = workTimeHour * 60 + workTimeMinute;
        const totalBreakTime =
          executionRestTimeHour * 60 + executionRestTimeMinute;

        const workTimeHourRemaining = Math.floor(
          (totalWorkTime - totalBreakTime) / 60
        );

        const workTimeHourAfterBreak =
          workTimeHourRemaining >= 0 ? workTimeHourRemaining : 0;
        const workTimeMinuteAfterBreak =
          workTimeHourRemaining >= 0
            ? (totalWorkTime - totalBreakTime) % 60
            : 0;

        console.log(
          "work time",
          workTimeHourAfterBreak.toString().padStart(2, "0") +
            ":" +
            workTimeMinuteAfterBreak.toString().padStart(2, "0")
        );
        newVal.schedulePackage.executionWorkTime =
          workTimeHourAfterBreak.toString().padStart(2, "0") +
          ":" +
          workTimeMinuteAfterBreak.toString().padStart(2, "0");

        const formValidation = this.$refs.form?.validate();
        if (this.completionReport.schedulePackage.paperSignFlg == "1") {
          this.$refs.signaturePad.clearSignature();
          this.$refs.signaturePad.lockSignaturePad();
          this.disableClearBtn = true;
        } else if (!formValidation || this.completionReport.noEditPermission) {
          this.$refs.signaturePad.lockSignaturePad();
          this.disableClearBtn = true;
        } else {
          this.$refs.signaturePad.openSignaturePad();
          this.disableClearBtn = false;
        }
      },
      deep: true
    }
  },
  methods: {
    deleteMeisai(completionReport, meisaiList, scheduleMeisai) {
      console.log("meisaiList", meisaiList, scheduleMeisai.keyId);
      const remainingMeisaiList = meisaiList.filter(
        item =>
          item.scheduleMeisaiResponse.scheduleMeisai.keyId !=
          scheduleMeisai.keyId
      );

      this.completionReport.deletedMeisai.push(scheduleMeisai.keyId);
      this.completionReport.deletedPackageMeisai.push(
        scheduleMeisai.packageMeisaiNo
      );

      const adjustedMeisaiList = remainingMeisaiList.map(item => {
        if (
          item.packageMeisai.packageMeisaiNo > scheduleMeisai.packageMeisaiNo
        ) {
          this.completionReport.deletedMeisai.push(
            item.scheduleMeisaiResponse.scheduleMeisai.keyId
          );
          this.completionReport.deletedPackageMeisai.push(
            item.scheduleMeisaiResponse.scheduleMeisai.packageMeisaiNo
          );
          return {
            ...item,
            packageMeisai: {
              ...item.packageMeisai,
              packageMeisaiNo: item.packageMeisai.packageMeisaiNo - 1
            },
            scheduleMeisaiResponse: {
              ...item.scheduleMeisaiResponse,
              scheduleMeisai: {
                ...item.scheduleMeisaiResponse.scheduleMeisai,
                packageMeisaiNo:
                  item.scheduleMeisaiResponse.scheduleMeisai.packageMeisaiNo -
                  1,
                keyId:
                  item.scheduleMeisaiResponse.scheduleMeisai.scheduleId +
                  "-" +
                  (item.scheduleMeisaiResponse.scheduleMeisai.packageMeisaiNo -
                    1)
              },
              scheduleWorkAreaList: item.scheduleMeisaiResponse.scheduleWorkAreaList.map(
                workArea => {
                  return {
                    ...workArea,
                    meisaiId:
                      workArea.scheduleId +
                      "-" +
                      (item.packageMeisai.packageMeisaiNo - 1),
                    keyId:
                      workArea.scheduleId +
                      "-" +
                      (item.packageMeisai.packageMeisaiNo - 1) +
                      "-" +
                      workArea.serialNumber
                  };
                }
              )
            }
          };
        }
        return item;
      });

      completionReport.packageMeisaiResponseList = adjustedMeisaiList;

      console.log(
        "updated meisaiList",
        completionReport.packageMeisaiResponseList,
        scheduleMeisai.keyId,
        this.completionReport.deletedMeisai,
        this.completionReport.deletedPackageMeisai
      );
    },
    deleteWorkArea(scheduleMeisaiResponse, workAreaList, workArea) {
      console.log("workAreas", workAreaList, workArea.keyId);
      const remainingWorkAreaList = workAreaList.filter(
        item => item.keyId != workArea.keyId
      );

      this.completionReport.deletedWorkArea.push(workArea.keyId);

      const adjustedWorkAreaList = remainingWorkAreaList.map(item => {
        if (item.serialNumber > workArea.serialNumber) {
          this.completionReport.deletedWorkArea.push(item.keyId);
          return {
            ...item,
            serialNumber: item.serialNumber - 1,
            keyId: item.meisaiId + "_" + (item.serialNumber - 1)
          };
        }
        return item;
      });

      scheduleMeisaiResponse.scheduleWorkAreaList = adjustedWorkAreaList;
      console.log(
        "updated workAreas",
        scheduleMeisaiResponse.scheduleWorkAreaList,
        workArea.keyId,
        this.completionReport.deletedWorkArea
      );
    },
    changeOther(status, workArea) {
      if (status == "status") {
        console.log("change status", status, workArea);
        workArea.processingScheduleNextmonth = "0";
        workArea.processingScheduleHold = "0";
        workArea.processingScheduleNextcycle = "0";
      }
      if (status == "nextmonth") {
        console.log("change status", status, workArea);
        workArea.status = "0";
        workArea.processingScheduleHold = "0";
        workArea.processingScheduleNextcycle = "0";
      }
      if (status == "hold") {
        console.log("change status", status, workArea);
        workArea.status = "0";
        workArea.processingScheduleNextmonth = "0";
        workArea.processingScheduleNextcycle = "0";
      }
      if (status == "nextcycle") {
        console.log("change status", status, workArea);
        workArea.status = "0";
        workArea.processingScheduleNextmonth = "0";
        workArea.processingScheduleHold = "0";
      }
    },
    resizeHandler() {
      const canvas = this.$refs.signaturePad.$el.querySelector("canvas");
      // if(isEmpty && !this.isEdit) {
      if (this.$refs.signaturePad.isEmpty()) {
        canvas.width = 500;
        canvas.height = 250;
        console.log("resizeHandler canvas", canvas);
      }
    },
    addScheduleWorkArea(item, scheduleMeisai) {
      const cloneObj = { ...item[item.length - 1] };
      console.log("cloneobj", cloneObj);
      cloneObj.serialNumber = (cloneObj.serialNumber ?? 0) + 1;
      cloneObj.keyId =
        (cloneObj.meisaiId ?? scheduleMeisai.keyId) +
        "_" +
        cloneObj.serialNumber;
      cloneObj.workArea = "";
      cloneObj.workAreaSuu = "";
      cloneObj.workAreaZansuu = "";
      cloneObj.status = "0";
      cloneObj.processingScheduleNextmonth = "0";
      cloneObj.processingScheduleHold = "0";
      cloneObj.processingScheduleNextcycle = "0";
      cloneObj.addFlag = "1";
      cloneObj.separationFlag = "1";
      cloneObj.displayFlag = "1";
      console.log("updated cloneobj", cloneObj);

      item.push(cloneObj);
    },
    addScheduleMeisai(item) {
      const cloneObj = JSON.parse(JSON.stringify(item[item.length - 1]));
      console.log(
        "cloneobj",
        cloneObj,
        cloneObj.scheduleMeisaiResponse.scheduleWorkAreaList.length
      );
      cloneObj.packageMeisai.packageMeisaiNo =
        cloneObj.packageMeisai.packageMeisaiNo + 1;

      cloneObj.packageMeisai.area = "";
      cloneObj.packageMeisai.cycle = 0;
      cloneObj.packageMeisai.floor = "";
      cloneObj.packageMeisai.workPattern = "";
      cloneObj.packageMeisai.workarea = "";
      cloneObj.packageMeisai.workareaSuu = "";
      cloneObj.packageMeisai.workareaSuuKbn = "";

      cloneObj.scheduleMeisaiResponse.scheduleMeisai.keyId =
        cloneObj.scheduleMeisaiResponse.scheduleMeisai.scheduleId +
        "_" +
        cloneObj.packageMeisai.packageMeisaiNo;

      cloneObj.scheduleMeisaiResponse.scheduleMeisai.packageMeisaiNo =
        cloneObj.packageMeisai.packageMeisaiNo;

      cloneObj.scheduleMeisaiResponse.scheduleMeisai.area = "";
      cloneObj.scheduleMeisaiResponse.scheduleMeisai.floor = "";
      cloneObj.scheduleMeisaiResponse.scheduleMeisai.workPattern = "";
      cloneObj.scheduleMeisaiResponse.scheduleMeisai.addFlag = "1";
      cloneObj.scheduleMeisaiResponse.scheduleMeisai.separationFlag = "1";
      const scheduleWorkArea = {
        ...cloneObj.scheduleMeisaiResponse.scheduleWorkAreaList[
          cloneObj.scheduleMeisaiResponse.scheduleWorkAreaList.length - 1
        ]
      };
      scheduleWorkArea.serialNumber = 1;
      scheduleWorkArea.meisaiId =
        cloneObj.scheduleMeisaiResponse.scheduleMeisai.keyId;
      scheduleWorkArea.keyId =
        scheduleWorkArea.meisaiId + "_" + scheduleWorkArea.serialNumber;
      scheduleWorkArea.workArea = "";
      scheduleWorkArea.workAreaSuu = "";
      scheduleWorkArea.workAreaZansuu = "";
      scheduleWorkArea.status = "0";
      scheduleWorkArea.processingScheduleNextmonth = "0";
      scheduleWorkArea.processingScheduleHold = "0";
      scheduleWorkArea.processingScheduleNextcycle = "0";
      scheduleWorkArea.addFlag = "1";
      scheduleWorkArea.separationFlag = "1";
      scheduleWorkArea.displayFlag = "1";

      cloneObj.scheduleMeisaiResponse.scheduleWorkAreaList = [scheduleWorkArea];
      console.log("updated cloneobj", cloneObj);
      item.push(cloneObj);
    },
    base64ToBlob(base64, contentType = "", sliceSize = 512) {
      const byteCharacters = atob(base64.split(",")[1]);
      const byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    getSign(completionReport) {
      if (completionReport.schedulePackage.digitalSign) {
        console.log(
          "image completionreport",
          this.completionReport.schedulePackage.keyId
        );
        fetch(
          this.BaseURL +
            "/schedulepackage/getImage/digitalSign?token=" +
            this.$store.state.mtoken +
            "&keyId=" +
            this.completionReport.schedulePackage.keyId
        )
          .then(raw => raw.blob())
          .then(blob => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
              //console.log(this.$refs.signaturePad);
              const canvas = this.$refs.signaturePad.$el.querySelector(
                "canvas"
              );
              canvas.width = 500;
              canvas.height = 250;

              //console.log("sign data", reader.result);
              this.$refs.signaturePad.fromDataURL(reader.result, {
                width: canvas.width,
                height: canvas.height,
                xOffset: 0,
                yOffset: 0
              });

              //this.isSignExits = reader.result == this.blankSign;
            };
          });
      } else {
        console.log("no sign exits so clear signaurePad");
        this.$refs.signaturePad?.clearSignature();
      }
    },
    onClose() {
      this.isEdit = false;
      this.isHistory = false;
    },
    onSignatureDrawn() {
      this.hasSignature = !this.$refs.signaturePad.isEmpty();
    },
    async clear() {
      console.log("clear");

      const confirm = await this.$deleteConfirm(
        "電子サインをクリアします。よろしいですか？"
      );
      console.log("confirm", confirm);
      if (confirm) {
        this.$refs.signaturePad.clearSignature();
        this.hasSignature = false;
      }
    },
    async onPaperSignClick() {
      console.log("onPaperSignClick");
      const isOn = this.completionReport.schedulePackage.paperSignFlg == "1";
      if (isOn) {
        // ON → OFF（サインに影響なし・即実行）
        this.completionReport.schedulePackage.paperSignFlg = null;
        if (this.completionReport.noEditPermission) {
          this.$refs.signaturePad.lockSignaturePad();
          this.disableClearBtn = true;
        } else {
          this.$refs.signaturePad.openSignaturePad();
          this.disableClearBtn = false;
        }
        return;
      }
      // OFF → ON：サイン済みなら確認
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (!isEmpty) {
        const confirm = await this.$deleteConfirm(
          "電子サインをクリアします。よろしいですか？"
        );
        if (!confirm) {
          // 再マウントで未チェック表示へ強制同期
          this.paperSignKey++;
          return;
        }
      }
      this.completionReport.schedulePackage.paperSignFlg = "1";
      this.$refs.signaturePad.clearSignature();
      this.$refs.signaturePad.lockSignaturePad();
      this.disableClearBtn = true;
    },
    async search() {
      this.listOfWorkReport = [];
      this.$loading();
      console.log("created", this.dateFrom);
      try {
        const param = {
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
          personInCharge: this.personInCharge
          //referBack: this.referBack
        };
        const encode = encodeURI(JSON.stringify(param));
        const result = await this.$get(
          this.Paths.scheduleDetail,
          "query=" + encode
        );
        if (result.length > 0) {
          this.listOfWorkReport = result;

          console.log("result", this.listOfWorkReport);
        }
      } catch (e) {
        this.$error(e.message);
      } finally {
        this.$unloading();
      }
    },
    async addspot() {
      const aff = [];
      const pack = [];
      const mei = [];
      const date = new Date(this.date);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      for (let i = 0; i < 11; i++) {
        if (i == 0) {
          mei.push({
            rowspan: 0,
            status: year + "-" + ("00" + month).slice(-2),
            code: "",
            sepalate: "",
            name: ""
          });
        } else {
          mei.push({
            rowspan: 0,
            status: "",
            code: "",
            sepalate: "",
            name: ""
          });
        }
      }

      pack.push({
        hojinCd: "",
        hospitalCd: "",
        index: "",
        packageMeisaiNo: "",
        packageNo: "",
        packagemeisais: mei,
        rowindex: "",
        rowspan: ""
      });

      aff.push(pack);
      //const props = { args: aff};

      const result = await this.$showDialog(ScheduleFixDialog, aff);

      if (result) {
        //this.$loading();

        try {
          this.search();
        } catch (e) {
          console.log(e);
          this.$error(e.message);
        } finally {
          //this.$unloading();
        }
      }
    },
    async onAdd() {
      console.log("Add");
      this.disableSave = true;
      const form = this.$refs.form;
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      const rt = await this.$confirm(
        "追加作業を登録できるようにしますが、よろしいでしょうか？\n登録すると、自動的に一覧に戻りますので、ご注意ください。",
        "確認"
      );
      if (!rt) return;

      const formdata = new FormData();
      const digitalSign = data;

      if (
        this.completionReport.schedulePackage.executionStartTime &&
        this.completionReport.schedulePackage.executionStartTime.length == 5
      ) {
        this.completionReport.schedulePackage.executionStartTime =
          this.completionReport.schedulePackage.executionStartTime + ":00";
      }
      if (
        this.completionReport.schedulePackage.executionEndTime &&
        this.completionReport.schedulePackage.executionEndTime.length == 5
      ) {
        this.completionReport.schedulePackage.executionEndTime =
          this.completionReport.schedulePackage.executionEndTime + ":00";
      }

      if (isEmpty) {
        formdata.append(
          "completionReport",
          JSON.stringify(this.completionReport)
        );
        //digitalSign = this.blankSign;
      } else {
        formdata.append(
          "digitalSign",
          this.base64ToBlob(digitalSign, "image/png")
        );
        formdata.append(
          "completionReport",
          JSON.stringify(this.completionReport)
        );
      }

      await this.$multiPartPost(this.Paths.schedulePackageAdd, formdata);

      const confirm = await this.$info(
        "作業を追加しました。一覧画面に戻ります。\n追加作業は、一覧から選択をお願いします。"
      );
      console.log("confirm", confirm);
      if (!confirm) {
        this.isEdit = false;
        this.search();
      }
    },
    async click(tempSave) {
      console.log("click");
      this.disableSave = true;
      const form = this.$refs.form;
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (!tempSave) {
        if (
          !form.validate() ||
          (isEmpty && this.completionReport.schedulePackage.paperSignFlg != "1")
        ) {
          this.$error(
            "未入力の項目があります。\n 入力内容や電子サインを確認してください。"
          );
          this.disableSave = false;
          return;
        }
      } else {
        if (
          !isEmpty ||
          this.completionReport.schedulePackage.paperSignFlg == "1"
        ) {
          this.$error(
            "電子サインや作業完了書で受領済みです。\n 一時保存は利用できません。\n 登録を行ってください。"
          );
          this.disableSave = false;
          return;
        }
      }
      if (tempSave) this.completionReport.schedulePackage.state = "TEMP";
      else this.completionReport.schedulePackage.state = "REGD";
      const formdata = new FormData();
      const digitalSign = data;
      this.parseDateTime();
      if (isEmpty) {
        formdata.append(
          "completionReport",
          JSON.stringify(this.completionReport)
        );
        //digitalSign = this.blankSign;
      } else {
        formdata.append(
          "digitalSign",
          this.base64ToBlob(digitalSign, "image/png")
        );
        formdata.append(
          "completionReport",
          JSON.stringify(this.completionReport)
        );
      }
      console.log(
        "saveSign",
        isEmpty,
        digitalSign,
        "completionReport : ",
        this.completionReport,
        "FormData : ",
        formdata
      );
      await this.$multiPartPost(this.Paths.schedulePackageUpdate, formdata);
      const confirm = await this.$info(
        tempSave ? "一時保存されました。" : "登録されました。"
      );
      console.log("confirm", confirm);
      if (!confirm) {
        this.isEdit = false;
        this.search();
      }
    },
    async inspect() {
      const form = this.$refs.form;
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      if (
        !form.validate()
        // ||
        // (isEmpty && this.completionReport.schedulePackage.paperSignFlg != "1")
      ) {
        // await this.$error(
        //   "未入力の項目があります。\n 入力内容や電子サインを確認してください。"
        // );
        await this.$error(
          "未入力の項目があります。\n 入力内容を確認してください。"
        );
        return;
      }
      this.data = data;

      this.formData = new FormData();
      await this.parseDateTime();

      if (isEmpty) {
        this.formData.append(
          "completionReport",
          JSON.stringify(this.completionReport)
        );
      } else {
        this.formData.append(
          "digitalSign",
          this.base64ToBlob(data, "image/png")
        );
        this.formData.append(
          "completionReport",
          JSON.stringify(this.completionReport)
        );
      }

      this.inspecting = true;
      try {
        const pdfBlob = await this.$multiPartPostAndDownload(
          this.Paths.inspectPDF,
          this.formData
        );

        console.log("Completion Report:");
        console.log(this.completionReport);

        this.pdfUrl = URL.createObjectURL(pdfBlob);

        this.openPdfViewer = true;
      } catch (e) {
        await this.$error(e.message);
        console.log(e);
      } finally {
        this.inspecting = false;
        console.log("pdf:viewer opened");
      }
    },
    async downloadExcel() {
      this.$loading();

      const form = this.$refs.form;
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      if (
        !form.validate()
        // ||
        // (isEmpty && this.completionReport.schedulePackage.paperSignFlg != "1")
      ) {
        // await this.$error(
        //   "未入力の項目があります。\n 入力内容や電子サインを確認してください。"
        // );
        await this.$error(
          "未入力の項目があります。\n 入力内容を確認してください。"
        );
        return;
      }
      this.data = data;

      this.formData = new FormData();
      await this.parseDateTime();

      if (isEmpty) {
        this.formData.append(
          "completionReport",
          JSON.stringify(this.completionReport)
        );
      } else {
        this.formData.append(
          "digitalSign",
          this.base64ToBlob(data, "image/png")
        );
        this.formData.append(
          "completionReport",
          JSON.stringify(this.completionReport)
        );
      }

      try {
        const result = await this.$multiPartPostAndDownload(
          this.Paths.inspect,
          this.formData
        );

        console.log("Completion Report:");
        console.log(this.completionReport);

        const url = URL.createObjectURL(result);
        console.log(url);
        const link = document.createElement("a");
        link.href = url;
        link.download = "定期作業完了書.zip";
        link.click();
        URL.revokeObjectURL(url);
      } catch (e) {
        await this.$error(e.message);
        console.log(e);
      } finally {
        this.$unloading();
        console.log("excel:download", "end");
      }
    },
    async parseDateTime() {
      if (
        this.completionReport.schedulePackage.executionStartTime &&
        this.completionReport.schedulePackage.executionStartTime.length === 5
      ) {
        this.completionReport.schedulePackage.executionStartTime =
          this.completionReport.schedulePackage.executionStartTime + ":00";
      }
      if (
        this.completionReport.schedulePackage.executionEndTime &&
        this.completionReport.schedulePackage.executionEndTime.length === 5
      ) {
        this.completionReport.schedulePackage.executionEndTime =
          this.completionReport.schedulePackage.executionEndTime + ":00";
      }
    },
    async edit(completionReport) {
      console.log("edit");
      this.isEdit = true;
      this.disableSave = false;

      const editCompletionReport = JSON.parse(JSON.stringify(completionReport));
      console.log("edit completionReport", editCompletionReport);
      this.completionReport = editCompletionReport;
      this.getSign(completionReport);
    },
    async history(completionReport) {
      console.log("history");
      this.isHistory = true;

      console.log("history completionReport)", this.completionReport);
      this.completionReport = completionReport;
    },
    closePdfViewer() {
      this.pdfUrl = null;
      this.openPdfViewer = false;
      this.formdata = new FormData();
      this.data = null;
    }
  },
  async created() {
    this.$loading();
    console.log(
      "created",
      this.dateFrom,
      this.dateTo,
      this.$route?.params.referBack
    );

    try {
      // if (this.$route?.params.referBack) {
      //   this.referBack = this.$route.params.referBack;
      // }
      const param = {
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        personInCharge: this.personInCharge
        //referBack: this.referBack
      };
      const encode = encodeURI(JSON.stringify(param));
      const result = await this.$get(
        this.Paths.scheduleDetail,
        "query=" + encode
      );
      if (result.length > 0) {
        this.listOfWorkReport = result;

        console.log("result", this.listOfWorkReport);
      }
    } catch (e) {
      await this.$error(e.message);
    } finally {
      this.$unloading();
    }
  },
  mounted() {
    console.log("mounted");
  }
};
</script>

<style lang="scss" scoped>
#signature {
  border: double 2px transparent;
  //border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #c4b9b9, #c4b9b9);
  background-origin: border-box;
  background-clip: content-box, border-box;
  //#94ce0e
  //#989b93
}
.custom-border {
  border: 1px solid #c4b9b9; /* Green border */
}
.work-time-error-text {
  color: #ff5252;
  font-size: 14px;
}
.work-time-error {
  border: 2px solid #ff5252 !important;
  //padding: 10px 0;
  //border-radius: 8px; /* Optional rounded corners */
}
.fixed {
  position: sticky;
  background-color: #ffffff;
  top: 0;
  z-index: 10;
}
</style>
